module.exports = __webpack_public_path__ + "img/GH-syoukai-top-logo002.7cb70068.png";